// react
import React from "react";

// components
import Button from "../../../../../components/Button";

type CompletedActionProps = {
	redirectURL: string;
	jobID?: string;
	name?: string;
};

const CompletedAction = ({ name = "", jobID = "", redirectURL }: CompletedActionProps) => {
	switch (name) {
		case "migration-create-workflows": {
			return (
				<div className="completed-action">
					<Button href="/company/workflows/">Go To Workflows</Button>
				</div>
			);
		}

		case "migration-create-goals": {
			return (
				<div className="completed-action">
					<Button
						href={`/employees/goals/?filters=%7B"status"%3A%5B%7B"value"%3A"active"%2C"label"%3A"Active"%7D%5D%7D`}
					>
						Go To Goals
					</Button>
				</div>
			);
		}

		case "create-cycle": {
			return (
				<div className="completed-action">
					<Button href={`/review-cycle/?jobID=${jobID}`}>Go To Cycle</Button>
				</div>
			);
		}

		case "generate-csv": {
			return (
				<div className="completed-action">
					<Button href={redirectURL}>Download</Button>
				</div>
			);
		}

		default: {
			return <div />;
		}
	}
};

export default CompletedAction;
